import React, { useEffect } from "react";
import DeltaData from "../components/DeltaData";
import { decoded } from "../Utils/UserProfile";
import { useNavigate } from "react-router";

const Delta = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (decoded === null) {
      window.location.href = "/";
    }
  }, [decoded]);
  return (
    <div className="innerContainer">
      <div className="dashboardPage">
        <DeltaData />
      </div>
    </div>
  );
};

export default Delta;
